/**
 * * 다국어 입력 폼 - 에피소드
 */

import React from 'react';
import styled from 'styled-components';
import { ILangDataList } from 'utils/types/common';
import DefaultInput from 'components/input/DefaultInput';
import DefaultTextArea from 'components/input/DefaultTextArea';

interface IProps {
  projectType?: string | number;
  // newLocalizingData?: ILangDataList[] | undefined;
  langList?: ILangDataList[] | undefined;
  imageDropList?: string[];
  onChange?: (e?: any) => void;
}
const LocalizingInputForm: React.FC<IProps> = ({
  projectType,
  onChange,
  langList,
}) => {
  // console.log(projectType);
  return (
    <LocalizingForm projectType={projectType}>
      {langList?.map((v) => (
        <div className='section_input'>
          <DefaultInput
            title='제목'
            name='title'
            id={`${v.lang}`}
            value={v.title}
            onChange={onChange}
            codeName={v.code_name ? v.code_name : ''}
            maxLength={30}
            top='true'
            localizing
            style={{ marginLeft: '0.5rem' }}
          />
          {projectType === 0 && (
            <DefaultTextArea
              title='요약'
              name='summary'
              id={`${v.lang}`}
              value={v.summary}
              onChange={onChange}
              maxLength={500}
            />
          )}
        </div>
      ))}
    </LocalizingForm>
  );
};

export default LocalizingInputForm;

const LocalizingForm = styled.form`
  .section_input {
    border-bottom: 1px solid rgba(217, 222, 227, 0.5);
    margin-bottom: ${(props) => (props.projectType === 0 ? '4rem' : '2rem')};
    padding-bottom: 2.5rem;
  }
`;
